var React = require("react");
var Login = require("./components/login");
var Screen = require("./components/screen");

var App = React.createClass({

  submit:function() {
    var form = document.querySelector("form");
    form.method = "POST";
    form.submit();
  },

  render:function() {

    return <Screen><Login onSubmit={this.submit}/></Screen>;

  }

});


React.render(<App/>,document.body);



// WEBPACK FOOTER //
// ./src/client/js/login.jsx